<template>
  <div>
    <OrderInfo
      ref="base"
      :techCuttingCode="params.code"
      :disabled="isDisableEditForm"
    />
  </div>
</template>
<script>
import OrderInfo from '../components/info'
export default {
  name: 'technology-techGoodsCutting-detail',
  components: {
    OrderInfo,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    onBeforeLeave(val) {
      if (val === 'base') {
        return true
      }
      if (!this.params.code || this.pageType === 'add') {
        this.$message.warning(
          this.$l('INDEX.tips_save_basicinfo_first') || '请先保存基本信息!'
        )
        return false
      }
    },
    save() {
      this.$refs.base.save()
    },
  },
}
</script>
